/**Import react section */
import React, { useState, useEffect } from 'react'
import propTypes from 'prop-types'
/**Import Material Ui section */
import { Grid, Typography } from '@material-ui/core'
import { useForm } from 'react-hook-form'
/**Import components section */
import TextBox from '../../common/TextBox'
import ButtonSaved from '../../common/Buttons/ButtonSaved'
import DateSelector from '../../common/DateSelector'
import NetworkDaysIndicator from './NetworkDaysIndicator'
import moment from 'moment'
import ReactSelectCommon from '../../common/ReactSelectCommon'
/**Import resources section */
import { createServicesStyle } from '../../../resources/styles/CreateServiceStyles'
import Authorization from '../../common/AuthorizationEvaluation'

import {
	SERVICE_PROVIDER_TECHNICIAN,
	SERVICE_PROVIDER_MANAGER,
	PORTAL_ADMINISTRATOR,
	DISPATCHER,
	IMBERA_TECHNICIAN,
	SPARE_PARTS_IMBERA_USA,
	SALES_MANAGER,
	SALES_REPRESENTATIVE_MANAGER,
	CUSTOMER_MANAGER,
	CUSTOMER_TECHNICIAN
} from '../../../resources/RolesEnum'
import { GetPhaseOptionsTypes } from '../../../store/helpers/SelectOptions'
const ContactForm = (props) => {
	const { onSaveService, isSavingService, isAuthorizadoForEditedData, isMobile, userProfile, problemDescription } = props
	const [contactForm, setContactForm] = useState(null)
	useEffect(() => {
		setContactForm(props.service)
	}, [props.service])
	useEffect(() => {
		if (problemDescription) {
			setContactForm((prevForm) => ({
				...prevForm,
				ProblemDescription: problemDescription
			}))
		}
	}, [problemDescription])

	const { control } = useForm()
	const classes = createServicesStyle()

	const updateData = () => {
		if (onSaveService && contactForm) {
			if (!contactForm.Token) {
				console.error('Token is required but missing')
				alert('Error: Token is required')
				return
			}
			const commandData = {
				Token: contactForm.Token,
				SiteContactName: contactForm.SiteContactName || null,
				SiteContactPhone: contactForm.SiteContactPhone || null,
				ContactName: contactForm.ContactName || null,
				ContactPhone: contactForm.ContactPhone || null,
				ServiceDescription: contactForm.ServiceDescription || null,
				ContactEmail: contactForm.ContactEmail || null,
				DispatcherUserName: contactForm.Dispatcher?.UserName || null, // Mapeo correcto
				TeachAssignedUserName: contactForm.TeachAssignedUserName || null,
				CommentProvider: contactForm.CommentProvider || null,
				StatusComments: contactForm.StatusComments || null,
				DispatchStatus: contactForm.DispatchStatus || null,
				ProblemDescription: contactForm.ProblemDescription || null,
				DispatchStatusPhase: contactForm.DispatchStatusPhase || null,
				DispatchStatusNote: contactForm.DispatchStatusNote || null,
				DispatchStatusDate: contactForm.DispatchStatusDate ? moment(contactForm.DispatchStatusDate).toDate() : null
			}
			onSaveService(commandData)
		}
	}

	const onPropertyChange = (event) => {
		let { name, value } = event.target
		setContactForm((prevForm) => ({
			...prevForm,
			[name]: value
		}))
	}

	const handleSelectChange = (name, selected) => {
		setContactForm((prevForm) => ({
			...prevForm,
			[name]: selected?.value || null
		}))
	}

	const renderTextBox = (key, item, label, isActive, isDisabled, size = 6, multiline = false, rows = 0, required) => {
		let value = item ? (item[key] ? item[key] : '') : ''
		return (
			<Grid item xs={size}>
				<TextBox
					key={key}
					active={isActive}
					disabled={isDisabled || isAuthorizadoForEditedData}
					fullWidth
					multiline={multiline}
					name={key}
					rows={rows}
					variant='outlined'
					margin='dense'
					label={label}
					onChange={onPropertyChange}
					value={value}
				/>
			</Grid>
		)
	}

	return (
		<>
			<Grid container spacing={2}>
				{contactForm &&
					contactForm.ServiceDescription &&
					renderTextBox('ServiceDescription', contactForm, 'COMMENTS', true, false, 12, true, 4, false)}
				{contactForm && !contactForm.ServiceDescription && (
					<Typography className={classes.textColor}>
						{' To add comments Click into the comment history tab below'} <br />
						<br />
					</Typography>
				)}

				<Grid item xs={12}>
					<Grid container justify='space-between' alignItems='center' wrap='nowrap'>
						<Grid item>
							<Typography className={classes.title}>{'CONTACT INFORMATION'}</Typography>
						</Grid>
						{contactForm && contactForm.NetworkDays !== null && contactForm.NetworkDays !== undefined && (
							<Grid item>
								<NetworkDaysIndicator value={contactForm.NetworkDays} />
							</Grid>
						)}
					</Grid>
				</Grid>
				{renderTextBox('ContactName', contactForm, 'Contact name', true, false, isMobile ? 12 : 6, false, 0, true)}
				{renderTextBox('ContactPhone', contactForm, 'Contact phone (mobile)', true, false, isMobile ? 12 : 6, false, 0, true)}
				{renderTextBox('SiteContactName', contactForm, 'Site contact name', true, false, isMobile ? 12 : 6, false, 0, true)}
				{renderTextBox('SiteContactPhone', contactForm, 'Site contact phone (mobile)', true, false, isMobile ? 12 : 6, false, 0, true)}
				{renderTextBox('ContactEmail', contactForm, 'Emails to send notifications e.g. (mail@mail.com,)', true, false, 12, false, 4, true)}
				{renderTextBox('StatusComments', contactForm, 'Status', true, false, 12, true, 4, true)}
				{!contactForm?.IsActivePhaseStatus ? (
					renderTextBox('DispatchStatus', contactForm, 'Dispatch Phase', true, false, 10, true, 0, true)
				) : (
					<>
						<Grid item xs={12} sm={6}>
							<DateSelector
								name='DispatchStatusDate'
								label='Dispatch Call Back Date'
								value={contactForm?.DispatchStatusDate ? moment(contactForm.DispatchStatusDate) : null}
								onChange={onPropertyChange}
								disabled={isAuthorizadoForEditedData}
								showIncon={false}
							/>
						</Grid>
						<Grid item xs={12} sm={6}>
							<div style={{ marginTop: '-10px' }}>
								<ReactSelectCommon
									id='dispatch-phase-select'
									name='DispatchStatusPhase'
									placeholder='Dispatch Phase'
									options={GetPhaseOptionsTypes()}
									value={GetPhaseOptionsTypes().find((opt) => opt.value === contactForm?.DispatchStatusPhase) || null}
									onChange={handleSelectChange}
									control={control}
									errors={{}}
									isDisabled={isAuthorizadoForEditedData}
								/>
							</div>
						</Grid>
						<Grid item xs={10}>
							<TextBox
								name='DispatchStatusNote'
								label='Service Ticket Status'
								variant='outlined'
								active={true}
								fullWidth
								margin='dense'
								value={contactForm?.DispatchStatusNote || ''}
								onChange={onPropertyChange}
								disabled={isAuthorizadoForEditedData}
								InputProps={{
									sx: {
										height: '56px'
									}
								}}
							/>
						</Grid>
					</>
				)}
				<Authorization
					profile={userProfile}
					allowedRoles={[
						SERVICE_PROVIDER_TECHNICIAN,
						SERVICE_PROVIDER_MANAGER,
						PORTAL_ADMINISTRATOR,
						DISPATCHER,
						IMBERA_TECHNICIAN,
						SPARE_PARTS_IMBERA_USA,
						SALES_MANAGER,
						SALES_REPRESENTATIVE_MANAGER,
						CUSTOMER_MANAGER,
						CUSTOMER_TECHNICIAN
					]}
				>
					<Grid item xs={2} className={classes.updateButton}>
						<Grid container spacing={1} alignItems='center'>
							<Grid item xs={12}>
								<ButtonSaved onSavedClick={updateData} title='Update' isSaving={isSavingService} />
							</Grid>
						</Grid>
					</Grid>
				</Authorization>
			</Grid>
		</>
	)
}

ContactForm.propTypes = {
	/**Determinate if update service data */
	isSavingService: propTypes.bool.isRequired,
	/**Function invoke callback for update contact info */
	onSaveService: propTypes.func.isRequired,
	isMobile: propTypes.bool.isRequired
}
ContactForm.defaultProps = {
	isSavingService: false,
	isMobile: false,
	onSaveService: () => console.warn('Callback [onSaveService] no defined')
}

export default ContactForm
